import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isLoading } from './app/selectors';
import { AppActions } from './app/slice';
import GalleryCard from './components/GalleryCard';
import GalleryFilters, { useGalleryFilters } from './components/GalleryFilters';
import './GalleryPage.scss';

const AllVideosPage: React.FC = () => {
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const { sortedEvents } = useGalleryFilters();

  useEffect(() => {
    if (!loading) return;
    dispatch(AppActions.startApp());
  }, [dispatch, loading]);

  return (
    <div className="gallery-page" data-testid="all-videos-page">
      <GalleryFilters />
      {loading ? (
        <div className="gallery-loading" role="status" aria-live="polite">
          Laden...
        </div>
      ) : (
        <div className="gallery-content">
          <section className="gallery-category">
            <div className="gallery-category__grid">
              {sortedEvents.map((event) => (
                <a key={event.id} href={event.pageURL} target="_top" aria-label={`Kurs ansehen: ${event.title}`}>
                  <GalleryCard
                    heading={event.title}
                    categories={event.categories}
                    authorName={event.presenterName}
                    authorTitle={event.presenterDescription}
                    authorImage={event.presenterImageURL}
                  />
                </a>
              ))}
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export default AllVideosPage;
